import React from 'react'
import styled from '@emotion/styled'

import { BDCLogo } from '../svgs/BDCLogo'
import { BNDLogo } from '../svgs/BNDLogo'

const ContextWrapper = styled.div`
	display: flex;
	flex-direction: ${({ modalView }) => (modalView === 'peeking' ? 'column-reverse' : 'column')};

	${({ theme }) => theme.MQ.M} {
		flex-direction: column-reverse;
		width: 95%;
	}
`
const LogosContainer = styled.div`
	align-content: flex-start;
	align-items: center;
	display: ${({ modalView }) => (modalView === 'peeking' ? 'none' : 'flex')};
	flex-direction: row;
	flex-flow: nowrap;
	justify-content: normal;
	width: 100%;

	svg {
		width: auto;
	}

	${({ theme }) => theme.MQ.M} {
		display: flex;
	}
`
const Ampersand = styled.div`
	${({ theme }) => theme.fonts.header};
	color: ${({ theme }) => theme.colors.primary};
	font-size: 32px;
	margin: 0.75rem;

	${({ theme }) => theme.MQ.M} {
		margin: 0;
		margin: 0 1rem;
	}

	${({ theme }) => theme.MQ.XL} {
		font-size: 52px;
		padding-left: 0.5rem;
		font-weight: 600px;
	}
`
const Message = styled.div`
	font-size: 16px;
	margin: auto 0;
	width: 100%;
	${({ modalView }) =>
		modalView === 'peeking' &&
		`
		left: 0;
		text-align: center;
		`}
	${({ theme }) => theme.MQ.M} {
		font-size: 18px;
		margin-bottom: 0.5rem;
		position: relative;
		text-align: left;
	}
	${({ theme }) => theme.MQ.L} {
		font-size: 20px;
	}
`

export function FloaterBarContextBnd({ isMobileView, modalView }) {
	return (
		<ContextWrapper modalView={modalView}>
			<LogosContainer modalView={modalView}>
				<BNDLogo color="white" height="40" width="auto" />
				<Ampersand>&amp;</Ampersand>
				<BDCLogo variant="white" color="white" circleFillColor="white" height="30" width="auto" />
			</LogosContainer>
			<Message modalView={modalView}>
				{isMobileView && modalView === 'peeking'
					? 'Build Your Business'
					: 'Build your business with the best resources on finance, marketing, HR and more.'}
			</Message>
		</ContextWrapper>
	)
}
